import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, merge, Observable, of } from 'rxjs';
import { mapTo } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MmuConnectionService {
  private _isOnlineSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  isOnline$: Observable<boolean> = this._isOnlineSubject.asObservable();

  constructor() {
    merge(of(navigator.onLine), fromEvent(window, 'online').pipe(mapTo(true)), fromEvent(window, 'offline').pipe(mapTo(false))).subscribe(
      (isOnline) => {
        this._isOnlineSubject.next(isOnline);
      }
    );
  }
}
